import React from 'react';
import { TMenuContentVersion } from 'types';
import FormInput from 'components/Input/FormInput';

interface IContentVersionField {
	changeContentVersion: (value: string) => void;
	useContentVersion: TMenuContentVersion;
}

const ContentVersionField: React.FC<IContentVersionField> = ({ changeContentVersion, useContentVersion }) => {
	// const handleChange = useCallback(
	// 	(e: React.ChangeEvent<HTMLInputElement>) => {
	// 		e.target.maxLength = 10;
	// 		const onlyDigits = e.target.value.replace(/\D/g, '');
	// 		const validValue = onlyDigits.replace(/^(\d{8})(\d)/, '$1-$2');
	// 		changeContentVersion(validValue);
	// 		return validValue;
	// 	},
	// 	[changeContentVersion],
	// );

	return (
		<FormInput
			testId="ContentVersionField"
			name="restaurantContentVersion"
			label="contentVersionLabel"
			placeholder="contentVersionPlaceholder"
			// getValueFromEvent={handleChange}
			onChange={changeContentVersion}
			disabled={useContentVersion === 'Customer'}
		/>
	);
};

export default React.memo(ContentVersionField);
